import conditionsCommon from "./reusable/conditionsCommon";

/**
 * Mixin used for handling 'Show/Hide field' conditions
 */
export default {
  props: [
    'conditions',
  ],
  data: function () {
    return {
      fieldHiddenMap: {}
    }
  },
  mixins: [conditionsCommon],
  methods: {
    renderShowHideFieldConditions() {
      this.clearObject(this.fieldHiddenMap)

      if (this.conditions != null) {
        this.conditions.forEach(obj => {
          // if there is no primaryState cond specified set it to true
          const isPrimaryStateCondTrue = obj.primaryState ? this.getStateForCondition(obj.primaryState) : true;

          // render actions if "ALL" is TRUE and every condition met, or ALL is FALSE and at least one condition is met
          if (
            (obj.all === 'true' && obj.states.every(e => this.getStateForCondition(e)) && isPrimaryStateCondTrue) ||
            (obj.all === 'false' && obj.states.some(e => this.getStateForCondition(e)) && isPrimaryStateCondTrue)
          ) {
            obj.todo.forEach(todo => {
              // hide === '0', show === '1'
              this.fieldHiddenMap[todo.field] = todo.action === '0'
            })
          }
        });
      }
    },
    isFieldHidden(field) {
      if (this.fieldHiddenMap.hasOwnProperty(field.name)) {
        return this.fieldHiddenMap[field.name]
      }

      return !!field.hide;
    }
  },
}



// WEBPACK FOOTER //
// ./src/mixins/formRender/showHideFieldConditions.js